import { Component, OnInit } from '@angular/core';

import { ActivatedRoute, Router } from '@angular/router';

import { BalanceDetailsSearchHandler} from './balance-details-search.handler';

import { HeaderService } from 'src/app/system-common/services/header.service';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { FinanceService } from '../services/finance.service';

@Component({
  selector: 'sym-balance-details-search',
  templateUrl: './balance-details-search.component.html',
  styleUrls: ['./balance-details-search.component.scss'],
})
export class BalanceDetailsSearchComponent extends BalanceDetailsSearchHandler implements OnInit {
  constructor(
    public service: FinanceService,
    public headerService: HeaderService,
    public router: Router,
    public settingService: SettingService,
    public route: ActivatedRoute
  ) {
    super(service, headerService, router, settingService, route);
  }

  ngOnInit() {
    super.ngOnInit();
  }
}
